import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import React from 'react';

import { NoticesWorkOrdersData } from '../../../../../../api/theHive/notices/types';
import { formatOnlyDate } from '../../../../../../helpers';
import {
  TableCellHeader,
  StyledCell,
  StyledRow,
  StyledPagination,
} from './styles';

interface WorkOrderTableProps {
  data: NoticesWorkOrdersData[];
  page: number;
  totalPages: number;
  setPage: (value: number) => void;
}

export default function WorkOrderTable({
  data,
  page,
  totalPages,
  setPage,
}: WorkOrderTableProps): JSX.Element {
  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ): void => {
    setPage(value);
  };

  return (
    <>
      <Typography color="common.grey" fontSize={21} fontWeight={600} mb={3}>
        Histórico de atribuição de OS
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCellHeader width="20%">OS</TableCellHeader>
              <TableCellHeader align="center" width="30%">
                Data de atribuição
              </TableCellHeader>
              <TableCellHeader align="center" width="50%">
                Credenciado
              </TableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((item) => (
                <StyledRow key={item.work_order.id}>
                  <StyledCell>{item.work_order.reference_number}</StyledCell>
                  <StyledCell align="center">
                    {item.accepted_at ? formatOnlyDate(item.accepted_at) : '-'}
                  </StyledCell>
                  <StyledCell align="center">
                    {item.worker_company.name}
                  </StyledCell>
                </StyledRow>
              ))
            ) : (
              <StyledRow>
                <StyledCell colSpan={3} align="center">
                  Este edital ainda não possui ordens de serviço atribuídas.
                </StyledCell>
              </StyledRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <StyledPagination
        page={page}
        count={totalPages}
        onChange={handlePageChange}
      />
    </>
  );
}
